import {Fragment, useState} from 'react'
import { useTranslation } from "react-i18next"
import Swal from 'sweetalert2'
import { Container, Row, Col, Button, Form} from 'react-bootstrap'
import { Link } from 'react-router-dom'
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

interface UserFormState {
    email: string
    password: string
    roles?: string[]
    _id?: string
    active?: boolean
}

export default function Forgot() {
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(false)
    
    /**
     * Comprueba los datos del formulario
     * @param {*} e evento
     */
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        const form = e.currentTarget;
        const formData = new FormData(form);
        const clientEmail = formData.get("email") as string;

        setIsLoading(true)

        // Enviamos la petición al /forgotpassword con el email
        await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/forgot/sendmailrecovery', {email: clientEmail})
            .then((res) => {
                setIsLoading(false)
                // Mostramos el popup informativo
                Swal.fire({
                    showConfirmButton: true,
                    icon: 'success',
                    text:  t('forgot.viewemail'),
                    target: document.getElementById('root')
                })
            }).catch((err) => {
                setIsLoading(false)
                // Mostramos el popup informativo
                Swal.fire({
                    showConfirmButton: true,
                    icon: 'error',
                    text: t('forgot.error')
                })
            })
    } 
    return (
        <Container className="login vh-100 d-flex align-items-center px-4">
            <Row className="px-4">
                <Container className="text-center text-white">
                    <Row className="mb-5">
                        <Col>
                            <img
                                src="/images/logotipo-aico.png"
                                alt="Logotipo Aico"
                                style={{ width: "100%" }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h1>{t('forgot.question')}</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            {t('forgot.help')}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form className="formulario" onSubmit={handleSubmit}>
                                <Row className="my-3">
                                    <Col>
                                        <Form.Label htmlFor='email'>{t('forgot.email')}</Form.Label>
                                        <Form.Control name="email" className="login" type="email" autoComplete="off" />
                                    </Col>
                                </Row>
                                <Row className="my-3">
                                    <Col>
                                        <Button variant='primary' type="submit" id="kt_password_reset_submit" className="w-100">
                                            {isLoading
                                                ?
                                                <>
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </>
                                                :
                                                <>{t('forgot.submit')}</>
                                            }
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='text-center pt-4'>
                                        {t('forgot.rememberpassword')}<br/>
                                        <Link to={`/${t("url.auth.login")}`} className='btn btn-secondary w-100 my-2'>
                                                {t('signin.login')}
                                        </Link>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </Row>
        </Container>
    )
}
